
       

<template>
  <div class="bg-white p-4 rounded shadow">
    <h2 class="text-lg font-bold mb-4">Logs</h2>
<div class="mb-4 flex gap-4 items-center">
  <label class="flex items-center space-x-1">
    <input type="checkbox" value="I" v-model="selectedLevels" />
    <span>Info</span>
  </label>
  <label class="flex items-center space-x-1">
    <input type="checkbox" value="W" v-model="selectedLevels" />
    <span>Warning</span>
  </label>
  <label class="flex items-center space-x-1">
    <input type="checkbox" value="E" v-model="selectedLevels" />
    <span>Error</span>
  </label>
</div>
    <div v-if="loading" class="text-gray-500">Chargement...</div>
    <ul v-else class="space-y-2">
      <li v-for="logFile in logFiles" :key="logFile.id">
        <button
          class="w-full text-left px-3 py-2 rounded hover:bg-blue-50 transition font-medium flex justify-between items-center"
          :class="{ 'bg-blue-100': isOpen(logFile) }"
          @click="toggle(logFile)"
        >
          <span>{{ logFile }}</span>
          <span class="text-sm text-gray-500">
            {{ isOpen(logFile) ? '−' : '+' }}
          </span>
        </button>

        <!-- Lazy load ONLY when opened -->
        <Suspense v-if="isOpen(logFile)">
          <template #default>
            <div class="mt-2 border-l-4 border-blue-500 pl-4">
              <AdminDeviceLogDetail :logFileName="logFile" :levels="selectedLevels" />
            </div>
          </template>
          <template #fallback>
            <div class="mt-2 pl-4 text-gray-400">Chargement...</div>
          </template>
        </Suspense>
      </li>
    </ul>

    <p v-if="error" class="text-red-600 mt-4">{{ error }}</p>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  components: {
    AdminDeviceLogDetail: defineAsyncComponent(() =>
      import('./AdminDeviceLogDetail.vue')
    )
  },
  data() {
    return {
      logFiles: [],
      loading: true,
      error: null,
      selectedLevels: ['I', 'W', 'E'], // tous cochés par défaut
    }
  },
  computed: {
    logId() {
      return this.$route.params.logFileName || null
    },
    deviceId() {
      return this.$route.params.deviceId
    }
  },
  methods: {
    isOpen(id) {
      return this.logId === id
    },
    toggle(id) {
      const base = `/admin/devices/${this.deviceId}/logs`
      if (this.isOpen(id)) {
        this.$router.push(base)
      } else {
        this.$router.push(`${base}/${id}`)
      }
    },
    
  },
  async mounted() {
    try {
      const res = await fetch(`${process.env.VUE_APP_AZURE_FUNCTION_URL}/api/deviceLogFiles?code=${process.env.VUE_APP_AZURE_FUNCTION_CODE}&deviceId=${this.deviceId}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
          }
        });
      if (!res.ok) throw new Error('Erreur de chargement')
      this.logFiles = await res.json()
    } catch (err) {
      this.error = err.message || 'Erreur inconnue'
    } finally {
      this.loading = false
    }
  }
}
</script>
